module.exports = __webpack_public_path__ + "static/media/wine-bottle.c6f18dea.svg";